<template>
    <div class="ppv2-flex ppv2-items-center ppv2-gap-1.5 ppv2-mr-3">
        <span class="dot" style="background-color: #ef4444; opacity: 0.75"></span>
        <span class="dot" style="background-color: #f59e0b; opacity: 0.75"></span>
        <span class="dot" style="background-color: #10b981; opacity: 0.75"></span>
    </div>
</template>

<script>
export default {
    name: 'TrafficLights',
}
</script>

<style scoped>
.dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    display: inline-block;
}
</style>
